<dialog #dialog class="modal sm:modal-middle">
    <div class="modal-box">
        <h3 class="text-lg font-bold">{{ 'Components.sessionTimeout.title' | transloco }}</h3>
        <p class="py-4">
            {{ 'Components.sessionTimeout.message' | transloco: { seconds: sessionTimeoutService.secondsRemaining() } }}
        </p>
        <div class="modal-action">
            <div class="flex flex-row gap-3 w-full justify-end">
                <button type="button" class="btn" (click)="logoutNow()">
                    {{ 'Components.sessionTimeout.logoutButton' | transloco }}
                </button>
                <button type="button" class="btn btn-primary" (click)="stayLoggedIn()">
                    {{ 'Components.sessionTimeout.stayButton' | transloco }}
                </button>
            </div>
        </div>
    </div>
</dialog>
